module.exports = __webpack_public_path__ + "static/bw-hero-new-593605f7c1b2e29ee9a8ea748875f331.svg";